<template>

        <v-card
            class="event mx-4 my-4"
            tag="article"
            max-width="500"
            outlined
        >
          <FavouritesButton
            :item="event"
           />
        <v-list-item three-line>
            <v-list-item-content @click="handleContentClick($event)">
                <router-link
                        :to="{ name: 'event', params: { id: event.id }}"
                        class="event__link"
                        ripple
                >
                    <v-list-item-title class="headline pl-3 pr-11"><p>{{event.name}}</p></v-list-item-title>
                    <v-card-text v-if="event.description" class="text pb-0 pt-0">
                        <p v-if="event.description.replace(/<\/?[^>]+(>|$)/g, '').length > 85" v-html="event.description.replace(/<\/?[^>]+(>|$)/g, '').substring(0,85)+'...'"></p>
                        <p v-else v-html="event.description.replace(/<\/?[^>]+(>|$)/g, '')"></p>


                    </v-card-text>
                    <v-list-item v-if="event.address_1">
                        <v-list-item-icon>
                            <v-icon color="primary" class="primary--text">mdi-map-marker</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-subtitle >{{hubbdata.event.labels.address}}</v-list-item-subtitle>
                            <v-list-item-title class="address">{{ event.address_1 }}, {{event.town}}, {{event.postcode}}</v-list-item-title>
                        </v-list-item-content>

                    </v-list-item>
                    <v-list-item v-if="event.next_occuring_date">
                        <v-list-item-icon>
                            <v-icon color="primary" class="primary--text">mdi-calendar</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-subtitle>{{hubbdata.event.labels.date}}</v-list-item-subtitle>
                            <v-list-item-title>{{ event.next_occuring_date | formatDate }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item v-if="event.descriptive_time">
                        <v-list-item-icon>
                            <v-icon color="primary" class="primary--text">mdi-clock</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-subtitle>{{hubbdata.event.labels.time}}</v-list-item-subtitle>
                            <v-list-item-title>{{ event.descriptive_time }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-card-actions>
                        <v-btn class="v-btn--outlined" text>{{hubbdata.catagories.info}}</v-btn>
                    </v-card-actions>

                </router-link>
            </v-list-item-content>
        </v-list-item>





        </v-card>
</template>

<script>
// import favourites from "@/favourites";
import hubbdata from "@/hubbdata";
import FavouritesButton from '@/components/Favourites/FavouritesButton.vue';

import moment from 'moment';

  export default {
    name: 'EventItem',
    props: {
        event: Object,
        eventIdx: Number,
        actionsDiabled: Boolean
    },
    data() {
        return {
            showInterestedUsers: false
        }
    },
    components: {
        FavouritesButton
    },
    computed: {
        hubbdata() {
            return hubbdata.getters.translations;
        },

    },
    methods: {

    },
    filters: {
        formatDate(value) {
            if (value) {
                return moment(String(value)).format('DD/MM/YYYY');
            }
        }
    },
  }

</script>

<style lang="scss" scoped>
    .event {
        img {
            max-width: 100%;
            width: 100%;
        }
        * {
            text-decoration: none;
        }
    }

    .event__link {
        text-decoration: none !important;
        max-width: 100%;

        .v-card__actions {
            @media (max-width: 576px) {
                display: flex;
                justify-content: center;
            }

            @media (min-width: 577px) {
                margin-left: 8px;
            }
        }

        .email {
        width: 165px;
        white-space: normal;
        }

        .address {
          white-space: normal;
        }

        .v-btn--outlined {
            background-color: $primary;
            // outline: 1px solid $dark;
            color: white!important;
            font-weight: 18px;
            text-transform: capitalize;
            margin: 0 auto;
            font-weight: bold;

            @media screen and (min-width: 960px) {
              font-size: 16px;
            }
        }
        .text {
            color: black !important;
            * {
                font-size: 14px !important;
            }

            @media screen and (min-width: 960px) {
              * {
                  font-size: 16px !important;
              }
            }
        }

        .headline {
            color: $primary !important;
            white-space: normal;
            font-size: 22px !important;
            margin-right: 60px;

        }

    }
</style>
